import { render } from "./RootInput.vue?vue&type=template&id=dc34eb0e&ts=true&lang=pug"
import script from "./RootInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./RootInput.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__